import React, { useState } from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';
import Select from 'react-select';
import { FaWhatsapp,FaCheckCircle } from 'react-icons/fa';
import { handleExist_user } from './shopModel';
import useToast from '../../../API/GlobalHooks/useToast';

const shopTypeOptions = [
  { value: 'Retail', label: 'Retail' },
  { value: 'Wholesale', label: 'Wholesale' },
  { value: 'Online', label: 'Online' },
];

const BasicInfo = ({verify, setVerify,verifyLoading}) => {
  const { setFieldValue, values } = useFormikContext();  
  const showToast = useToast();
  return (
    <>
      <div className="mb-3">
        <label htmlFor="shopName">Shop Name</label>
        <Field id="shopName" name="shopName" className="form-control form-control-sm" />
        <ErrorMessage name="shopName" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="shopType">Shop Type</label>
        <Select
          id="shopType"
          name="shopType"
          options={shopTypeOptions}
          value={shopTypeOptions.find(o => o.value === values.shopType)}
          onChange={opt => setFieldValue('shopType', opt.value)}
          classNamePrefix="react-select"
        />
        <ErrorMessage name="shopType" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="ownerName">Owner Name</label>
        <Field id="ownerName" name="ownerName" className="form-control form-control-sm" />
        <ErrorMessage name="ownerName" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="mob">Whatsapp Number</label>
        <div className="position-relative">
          <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#25D366' }}>
            <FaWhatsapp />
          </span>
          <Field
            id="mob"
            name="mob"
            type="text"
            inputMode="numeric"
            maxLength="10"
            onInput={e => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
            className="form-control form-control-sm ps-5"
            onBlur={(e)=>{
              if (e.target.value.length === 10) {
                // handleExist_user({mob:e.target.value,setVerifyLoading,setVerify,setFieldValue,showToast})               
              }              
            }}
          />
         {/* Right verify icon */}
         <span
          style={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: '#e6f8ef', // light green
            color: '#25D366',
            fontSize: '0.7rem',
            fontWeight: 500,
            borderRadius: '12px',
            padding: '2px 6px',
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          }}
          title="Verified"
        >
        {
          verifyLoading?(
            <span
              className="spinner-border spinner-border-sm"
              style={{ color: '#25D366', width: '0.8rem', height: '0.8rem' }}
              role="status"
            ></span>
          )
          :verify?( <><FaCheckCircle style={{ fontSize: '0.8rem' }} />
                  Verified</>)
          :"" 
        }
          
        </span>
        </div>
        <ErrorMessage name="mob" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="establishmentDate">Establishment Date</label>
        <Field id="establishmentDate" name="establishmentDate" type="date" className="form-control form-control-sm" />
        <ErrorMessage name="establishmentDate" component="div" className="text-danger small" />
      </div>
    </>
  );
};

export default BasicInfo;
